import LoginForm from '../components/LoginForm'
import Header from '../components/Header'

const Login = () => {
    return (
        <div className="page__layout page--login">
            <header className="page__header header">
                <Header />
            </header>

            <div className="page__mainWpr">
                <main className="page__main">
                    <LoginForm />
                </main>

            </div>

        </div>
    )
}

export default Login

